// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hibe-init-wrapper .path-example[data-v-8c09d61e]{color:var(--base-color-danger)}.hibe-init-wrapper .el-row[data-v-8c09d61e]{margin:0 calc(0px - var(--base-size-16))}.hibe-init-wrapper .el-row .el-col[data-v-8c09d61e]{padding:0 var(--base-size-16)}", ""]);
// Exports
module.exports = exports;
